import { gql, useMutation } from "@apollo/client";

import {
  DeviceMake,
  UpdateDeviceMakeInput,
  UpdateDeviceMakeMutation,
  UpdateDeviceMakeMutationVariables,
} from "../../../../../API";
import { UPDATE_DEVICE_MAKE } from "../../../../../common/operations/mutations";
import { successNotification } from "../../../../../common/variables/notification";
import { handleApolloError } from "../../../../../common/utils/handleApolloError";

export const useUpdateDeviceMake = () => {
  const [saveDeviceMake, { data, loading }] = useMutation<
    UpdateDeviceMakeMutation,
    UpdateDeviceMakeMutationVariables
  >(UPDATE_DEVICE_MAKE);

  const updateDeviceMake = async (input: UpdateDeviceMakeInput) => {
    return await saveDeviceMake({
      variables: {
        input,
      },
      onCompleted: response => {
        if (response.updateDeviceMake) {
          successNotification();
        }
      },
      onError: handleApolloError,
      update: (cache, response): void => {
        cache.modify({
          fields: {
            getDevicesMakes(existing) {
              const newDeviceMakeRef = cache.writeFragment({
                data: response.data?.updateDeviceMake,
                fragment: gql`
                  fragment NewDeviceMake on DeviceMake {
                    id
                    model
                    name
                    rtspTemplate
                    type
                  }
                `,
              });

              if (!existing) {
                return response?.data;
              }

              return {
                ...existing,
                items: existing.items.map((item: DeviceMake | null) => {
                  if (item?.model !== response.data?.updateDeviceMake?.model) {
                    return item;
                  }

                  return newDeviceMakeRef;
                }),
              };
            },
          },
        });
      },
    });
  };

  return { updateDeviceMake, data, loading };
};
